const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x1502faF09D2a3F11189237553Ff3c1E2e4508D80',
  busdAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  lpAddress: '0x19e7cbECDD23A16DfA5573dF54d98F7CaAE03019'
}

export default priceContracts